import { useEffect, useState } from "react";
import { api } from "../services/api";
import { normalizarProjetoBackend } from "../utils/projetos";

export function useProjetosBanco() {
  const [projetosBanco, setProjetosBanco] = useState([]);

  useEffect(() => {
    let ativo = true;

    async function carregarProjetosBanco() {
      try {
        const response = await api.get("/cards");
        if (!ativo) return;

        const cards = Array.isArray(response.data) ? response.data : [];
        setProjetosBanco(cards.map((card) => normalizarProjetoBackend(card)));
      } catch (error) {
        if (!ativo) return;
        setProjetosBanco([]);
      }
    }

    carregarProjetosBanco();

    return () => {
      ativo = false;
    };
  }, []);

  return projetosBanco;
}

export function useProjetosComBanco() {
  return useProjetosBanco();
}